import type { PayloadAction } from '@reduxjs/toolkit'

import { createSlice } from '@redux'

type AlertDialogState = {
  message: string
  title: string
  type: 'success' | 'error'
  open: boolean
  ctaTitle?: string
}

export const initialState: AlertDialogState = {
  message: '',
  type: 'success',
  title: '',
  open: false,
  ctaTitle: 'Done',
}

export const alertDialogSlice = createSlice('alertDialog', {
  name: 'alertDialog',
  initialState,
  reducers: {
    showAlertDialog: (
      state,
      action: PayloadAction<{
        message: string
        title: string
        type?: AlertDialogState['type']
        ctaTitle?: string
      }>,
    ) => {
      state.message = action.payload.message
      state.title = action.payload.title
      state.type = action.payload.type || 'success'
      state.open = true
      state.ctaTitle = action.payload.ctaTitle || 'Done'
    },
    hideAlertDialog: (state) => {
      state.open = false
    },
  },
})

export const { showAlertDialog, hideAlertDialog } = alertDialogSlice.actions
export default { alertDialog: alertDialogSlice.reducer }
